import React, { useState, useEffect } from 'react';
import '../styles/tradeHistory.css';

function TradeHistory() {

    // State to hold trade history data
    const [tradeData, setTradeData] = useState([]);
    const [userData, setUserData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    // Function to get the appropriate icon path based on coin pair
    const getTradeIcon = (pair) => {
        const iconMap = {
            BTCUSD: '/icons/Bitcoin.png', // Absolute path relative to public folder
            ETHUSD: '/icons/Ethereum.png', // Absolute path relative to
            XRPUSD: '/icons/xrp-logo.jpg',
            SHIBUSD: '/icons/shib.png',
            // Add more mappings for other coins (e.g., DOGEUSD: '/icons/Doge.png')
        };
        return iconMap[pair] || '/icons/Bitcoin.png'; // Default to Bitcoin icon if pair not found
    };

    // Fetch user data from localStorage on mount
    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            try {
                const user = JSON.parse(storedUser);
                setUserData(user);
            } catch (error) {
                console.error("Error parsing user data:", error);
                setError("Failed to retrieve user data.");
                setIsLoading(false);
            }
        } else {
            setError("No user data found in localStorage.");
            setIsLoading(false);
        }
    }, []);

    // Fetch trade data from API when userData is available
    useEffect(() => {
        const fetchTradeData = async () => {
            if (!userData || !userData.username) {
                setError("Username is not available.");
                setIsLoading(false);
                return;
            }

            setIsLoading(true);
            const encodedUsername = encodeURIComponent(userData.username);
            const baseUrl = process.env.REACT_APP_API_BASE_URL;
            const url = `${baseUrl}/orders/username/${encodedUsername}`;

            console.log("Request URL:", url);

            try {
                const response = await fetch(url);
                const data = await response.json();

                if (response.ok) {
                    // Transform API data to match dummy data structure
                      const transformedData = data.orders.map((order) => {
                        const profitLoss = parseFloat(order.profitLossAmount) || 0;
                        return {
                            id: order.id,
                            pair: `${order.pair.base_currency}${order.pair.quote_currency}`,
                            type: order.side === 'buy' ? 'Buy' : 'Sell',
                            priceRange: `${order.price || 'N/A'} - ${order.lastPrice || 'N/A'}`,
                            timestamp: order.created_at
                                ? new Date(order.created_at).toLocaleString('en-GB', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                }).replace(/,/, '')
                                : 'N/A',
                            amount: profitLoss >= 0 ? `+${profitLoss.toFixed(2)}` : profitLoss.toFixed(2),
                            isNegative: profitLoss < 0,
                            isPositive: profitLoss > 0,
                        };
                    });
                    setTradeData(transformedData);
                } else if (response.status === 404) {
                    setTradeData([]); // No orders found
                } else {
                    setError(data.message || "Failed to fetch trade data.");
                }
            } catch (err) {
                console.error("Fetch error:", err);
                setError("An error occurred while fetching trade data.");
            } finally {
                setIsLoading(false);
            }
        };

        if (userData && userData.username) {
            fetchTradeData();
        }
    }, [userData]);

    return (
        <div className="trade-history-page">
            <div className="trade-history-content">
                <table className="trade-table">
                    <thead>
                        <tr>
                            <th>Last Trade</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tradeData.length > 0 ? (
                            tradeData.map((trade, index) => (
                                <tr key={index} className={`trade-row ${index % 2 === 0 ? 'alt-row' : ''}`}>
                                    <td>
                                        <div className="trade-header">
                                            <img
                                                src={getTradeIcon(trade.pair)}
                                                alt={`${trade.pair} icon`}
                                                className="trade-icon"
                                            />
                                            <span className="trade-pair">{trade.pair}</span>
                                            <span
                                                className={`trade-type ${trade.type === 'Buy' ? 'buy-type' : 'sell-type'}`}
                                            >
                                                {trade.type}
                                            </span>
                                        </div>
                                        <div className="trade-details">
                                            {trade.priceRange}, {trade.timestamp}
                                        </div>
                                    </td>
                                    <td
                                            className={`trade-amount ${trade.isNegative ? 'negative-amount' : trade.isPositive ? 'positive-amount' : ''}`}
                                            style={{ color: trade.isNegative ? '#d32f2f' : trade.isPositive ? '#28a745' : 'inherit' }}
                                        >
                                            {trade.amount}
                                        </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="2">No trade history available.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <button className="load-more-button">LOAD MORE</button>
            </div>
        </div>
    );
}

export default TradeHistory;